import type { CSSProperties } from 'react';
import type { TextBlock as TextBlockDoc } from '../types';

/**
 * Textový blok. Prostý text, `\n` = nový řádek; ŽÁDNÉ HTML — renderer text
 * nevkládá přes innerHTML, takže z admina neteče žádná XSS plocha.
 */
export function TextBlock({ block }: { block: TextBlockDoc }) {
  const style: CSSProperties = { textAlign: block.align };
  if (block.color !== undefined) style.color = block.color;
  return (
    <p className={`layer-text layer-text-${block.variant}`} style={style}>
      {block.text}
    </p>
  );
}
